import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-024d88c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rkfx-processes" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-full my-auto text-lg font-semibold" }, "협력사", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-cross" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "py-5 px-8"
}
const _hoisted_6 = { class: "border-b border-line text-4xl font-bold" }
const _hoisted_7 = { class: "pb-2 border-b border-line text-xl font-semibold" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"flex px-3 py-3 border-b border-line bg-hover text-sm text-desc\" data-v-024d88c2><div style=\"min-width:15rem;max-width:15rem;\" data-v-024d88c2>협력사</div><div style=\"width:100%;\" data-v-024d88c2>장비</div><div style=\"min-width:15rem;max-width:15rem;\" data-v-024d88c2>출력크기</div><div style=\"min-width:10rem;max-width:10rem;\" data-v-024d88c2>단가</div><div style=\"min-width:10rem;max-width:10rem;\" data-v-024d88c2>최소비용</div></div>", 1)
const _hoisted_9 = { style: {"min-width":"15rem","max-width":"15rem"} }
const _hoisted_10 = {
  class: "pr-1 cs-ellipsis1",
  style: {"width":"220px","max-width":"220px"}
}
const _hoisted_11 = { style: {"min-width":"15rem","max-width":"15rem"} }
const _hoisted_12 = {
  class: "text-second font-semibold",
  style: {"min-width":"10rem","max-width":"10rem"}
}
const _hoisted_13 = { style: {"min-width":"10rem","max-width":"10rem"} }

import {Company} from "../../js/interface";

/******************************************
 * 하이쓰리디 - 설정의 공정 리스트 행
 ******************************************/

import {ref, defineComponent, defineEmits} from "vue";
import {storeToRefs} from "pinia";

import {CompanyStore} from "../../store/company-store";
import {numberToComma, removeComma} from "../../js/utils";

const __default__ = defineComponent({
  name: "AdminProcesses",
  components: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  currentModel: {
    type: Object,
  },
},
  emits: ["onShow"],
  setup(__props, { emit }) {

const props = __props;

const companyStore = CompanyStore();
const {processList} = storeToRefs(companyStore);





const isShow = ref(true);
const modelVolume = ref(0);

const onChangeShow = () => {
  isShow.value = !isShow.value;
  emit("onShow", isShow.value);
};

const unitCost = (company: Company) => {
  if (props.currentModel) {
    modelVolume.value = props.currentModel.modelVolume;
  }
  const v = modelVolume.value;
  const cost = company.costRate * v;
  const c = numberToComma(Math.floor(cost));
  return c;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "flex justify-between px-5 py-3" }, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "cs-icon-btn",
        onClick: onChangeShow
      }, _hoisted_4)
    ]),
    (__props.currentModel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processList), (process) => {
            return (_openBlock(), _createElementBlock("div", {
              key: process.id,
              class: "mb-10"
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(process.name), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(process.matarials, (material) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: material.id,
                  class: "mt-7 pl-4"
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(material.name), 1),
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(material.companys, (company) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: company.id,
                      class: _normalizeClass(["flex px-3 py-4 border-b border-line text-desc", {'rkfx-active': __props.currentModel.modelCompanyId === company.id}]),
                      style: {"min-width":"0"}
                    }, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(company.name), 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(company.printer), 1),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(`${company.buildX}x${company.buildY}x${company.buildZ}`), 1),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(unitCost(company)) + "원", 1),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(company.minCost) + "원", 1)
                    ], 2))
                  }), 128))
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})